<template>
  <p :class="[
    'timer',
    {
      expired: countdown < 0,
      neutral: countdown === null
    }
  ]">
    {{ formatCountdown(countdown) }}
  </p>
</template>

<script>
export default {
  name: 'DevizCard',
  props: {
    deviz: Object,
    countdown: Number,
  },
  methods: {
    formatCountdown(ms) {
      if (ms == null) return '--:--'
      const totalSeconds = Math.floor(ms / 1000)
      const negative = totalSeconds < 0
      const absSeconds = Math.abs(totalSeconds)

      const hours = String(Math.floor(absSeconds / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((absSeconds % 3600) / 60)).padStart(2, '0')
      return `${negative ? '-' : ''}${hours}:${minutes}`
    },
  },
}
</script>

<style scoped>
.timer {
  font-family: 'Courier New', Courier, monospace;
  font-size: 1.2rem;
  font-weight: 600;
  color: #2e7d32;
  background-color: #e8f5e9;
  border-radius: 6px;
  width: fit-content;
  user-select: none;
  transition: all 0.3s ease;
  box-shadow: 0 0 6px 1px rgba(46, 125, 50, 0.4);
  display: inline-block;
}

.timer.expired {
  color: #b71c1c;
  background-color: #ffebee;
  box-shadow: 0 0 10px 2px rgba(183, 28, 28, 0.6);
  transform: scale(1.03);
}

.timer.neutral {
  color: #555;
  background-color: #f0f0f0;
  box-shadow: 0 0 6px 1px rgba(150, 150, 150, 0.4);
  font-weight: 600;
  font-style: italic;
}

@media only screen and (max-width: 855px) {
  .timer {
    font-size: 0.8rem;
    padding: 4px 8px;
  }
}
</style>
